import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

if (window) {
    window.FontAwesomeConfig = { autoReplaceSvg: false }
}

console.log('React app script executing...');

const mountReactApp = () => {
  const rootElement = document.getElementById('root');
  console.log('Root element found:', rootElement);

  if (rootElement && !rootElement._reactRoot) {
    console.log('Creating React root...');
    const root = ReactDOM.createRoot(rootElement);
    rootElement._reactRoot = root;
    root.render(
      <React.StrictMode>
        <App />
      </React.StrictMode>
    );
    console.log('React app mounted successfully!');
  } else {
    console.log('Root element not found or already has React root');
  }
};

// Wait for DOM to be ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', mountReactApp);
} else {
  // DOM is already ready
  mountReactApp();
}
